var _defs, _rect, _g, _circle, _path, _rect2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinoDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7167cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7b267"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 40,
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#243f2b",
    transform: "translate(185 105) scale(2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 62h12V50h12V38h18V12h28v28H54v12H42v22H29V59H18v15H7V68H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 18,
    width: 12,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 23,
    width: 25,
    height: 16
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 176,
    r: 5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M590 300v-145m0 65h-50m50 28h60",
    stroke: "#26734d",
    strokeWidth: 28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 310,
    width: 800,
    height: 140,
    fill: "#402f3a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 405,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "sans-serif",
    fontSize: 62,
    fontWeight: 800
  }, "DINO DASH")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoDash);
export default __webpack_public_path__ + "static/media/dino_dash.b6eaef6f044f5529f5e50ddfb17c4ba0.svg";
export { ForwardRef as ReactComponent };